import React from 'react';
import { useTranslation } from 'react-i18next';

const ProportionalMapKey = () => {
  const { t } = useTranslation('wap');

  return (
    <div className="proportionalmap__key">
      <div className="proportionalmap__key-element proportionalmap__key-element--counted">
        {t('proportional_map_counted')}
      </div>
      <div className="proportionalmap__key-element proportionalmap__key-element--notcounted">
        {t('proportional_map_not_counted')}
      </div>
    </div>
  );
};

export default ProportionalMapKey;
